import type { eventWithTime } from '@carboncopyco/rrweb-types';
import type { TourFrame } from '@carboncopyco/types';
import { scopedLogger, Scope } from '@carboncopyco/logger';

const sdkLogger = scopedLogger(Scope.MIMESIS_SDK);

export const useReplayerReady = (
  frames: TourFrame[],
  events: eventWithTime[],
  uuid: string
) => {
  if (frames?.length === 0 || events?.length < 3 || !uuid) {
    sdkLogger.info('Replayer not ready! ', {
      frames,
      events,
      uuid,
    });

    return {
      isReady: false,
    };
  }

  return {
    isReady: true,
  };
};
